var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.686823 6.36973L5.60065 10.6672C5.82605 10.8644 6.16677 10.8385 6.36085 10.6108C6.55566 10.3826 6.53083 10.0382 6.30544 9.84101L2.53889 6.54742L10.961 6.54742C11.2586 6.54742 11.5 6.30326 11.5 6.00175C11.5 5.70023 11.2586 5.45607 10.961 5.45607L2.40346 5.45607L4.55034 3.51628L6.22739 2.17366C6.46055 1.98661 6.50067 1.64346 6.31589 1.40691C6.20959 1.27087 6.05164 1.1998 5.89243 1.1998C5.77534 1.1998 5.65725 1.23813 5.55822 1.31757L3.8571 2.68124L0.680527 5.54996C0.564695 5.65427 0.49901 5.80427 0.500011 5.96137C0.501515 6.11848 0.568982 6.26719 0.686823 6.36973Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/iconBack.5656a50d8f1fa5a6de7ebab940116339.svg";
export { ForwardRef as ReactComponent };